import { WithChildren } from '@eva/types/dto';

import type { GroupedTableClassNames, GroupRowState, RowState } from './types';

export const getGroupedListClassNames = (classNames: Partial<GroupedTableClassNames> = {}): GroupedTableClassNames => ({
  containerClassName: classNames.containerClassName || 'gl-container',

  groupWithChildrenClassName: classNames.groupWithChildrenClassName || 'gl-group-with-children',

  groupWithChildrenIsConfirmingClassName:
    classNames.groupWithChildrenIsConfirmingClassName || 'gl-group-with-children_confirming',

  controlClassName: classNames.controlClassName || 'gl-control',
  controlsClassName: classNames.controlsClassName || 'gl-controls',

  groupClassName: classNames.groupClassName || 'gl-group',

  groupContentClassName: classNames.groupContentClassName || 'gl-group__content',

  groupTitleClassName: classNames.groupTitleClassName || 'gl-group__title',
  groupControlsClassName: classNames.groupControlsClassName || 'gl-group__controls',

  groupInlineFormClassName: classNames.groupInlineFormClassName || 'gl-group__inline-form',

  itemClassName: classNames.itemClassName || 'gl-item',
  itemIsDraggingClassName: classNames.itemIsDraggingClassName || 'gl-item_dragging',
  itemIsSelectedClassName: classNames.itemIsSelectedClassName || 'gl-item_selected',
  itemIsConfirmingClassName: classNames.itemIsConfirmingClassName || 'gl-item_confirming',

  itemContentClassName: classNames.itemContentClassName || 'gl-item__content',
  itemTitleClassName: classNames.itemTitleClassName || 'gl-item__title',
  itemControlsClassName: classNames.itemControlsClassName || 'gl-item__controls',

  itemInlineFormClassName: classNames.itemInlineFormClassName || 'gl-item__inline-form',

  regularFormClassName: classNames.regularFormClassName || 'gl-group__regular-form',
});

export const rearrange = <I, G extends WithChildren<I>>(
  groups: G[],
  item: I,
  newItemIndex: number,
  nextGroupId: number,
  getItemId: (item: I) => number,
  getGroupId: (group: G) => number,
) => {
  const itemId = getItemId(item);
  let updatedGroups = groups.map((group) => ({
    ...group,
    children: group.children?.filter((child) => getItemId(child) !== itemId),
  }));

  const nextGroupIndex = updatedGroups.findIndex((g) => getGroupId(g) === nextGroupId);

  const nextGroup = updatedGroups[nextGroupIndex];

  const updatedNextChildren = nextGroup?.children || [];

  updatedNextChildren.splice(newItemIndex, 0, item);

  const updatedNextGroup = {
    ...nextGroup,
    children: updatedNextChildren,
  };

  updatedGroups = [
    ...updatedGroups.slice(0, nextGroupIndex),
    updatedNextGroup,
    ...updatedGroups.slice(nextGroupIndex + 1),
  ];

  return updatedGroups;
};

export const getDefaultGroupState = (): Partial<GroupRowState> => ({
  isExpanded: true,
});

export const getDefaultRowState = (): Partial<RowState> => ({});
